import React, {Component} from 'react'
import {LocationAuditSearchBar} from './LocationAuditSearchBar'
import {LocationsGrid} from './LocationsGrid'
import {reduce, get, forOwn, unset, keyBy, keys, merge, cloneDeep} from 'lodash'
import Loading from './Loading'
import {searchPlaces} from "./api";

export class LocationSearchTab extends Component {

  constructor(props) {
    super(props)
    const {accounts, locations, categories} = props
    this.state = ({
      rows: {},
      accounts: accounts.map(account => ({label: account.accountName, value: account})),
      categories,
      locations,
      loading: false,
      maxItems: 100 // TODO: add some extra paging logic after you search through 100 objects.
    })

    this.onAccountSelect = props.onAccountSelect
    this.makeSearchReq = this.makeSearchReq.bind(this)
    this.onSearchSubmit = this.onSearchSubmit.bind(this)
  }

  onSearchSubmit(searchParams) {
    this.makeSearchReq(searchParams)
  }


  makeSearchReq(searchParams) {
    this.setState({loading: true, error: false,});
    const pageSize = 20;
    const {maxItems} = this.state;

    const getPage = (page = 0, rows = {}, count = 0) => {

      return searchPlaces({...searchParams, offset: count, limit: pageSize})
        .then(({data}) => {
          let newRows = merge(rows, dataToRows(data.result));
          let newCount = count + data.result.length;

          if (data.result.length < pageSize || newCount >= maxItems) {
            return Promise.resolve(newRows)
          } else return getPage(page + 1, newRows, newCount)
        })
        .catch((err) => {
          console.log(`err: ${err}`);
          return Promise.reject(err)
        })
    }

    const dataToRows = (data) => {
      return keyBy(data.map(row => ({
          ...row,
          id: get(row, 'placeId', ''),
          name: get(row, 'busName', ''),
          streetAddress: get(row, 'street', ''),
          locality: get(row, 'city', ''),
          region: get(row, 'state', ''),
          postalCode: get(row, 'postalCode', ''),
          country: get(row, 'country', ''),
          phone: get(row, 'primaryPhone', ''),
          website: get(row, 'website', ''),
          email: get(row, 'email', ''),
          latitude: get(row, 'coordinates.latitude', ''),
          longitude: get(row, 'coordinates.longitude', ''),
        })),
        'id'
      )
    }
    getPage()
      .then(rows => {
          this.setState({rows, ...searchParams, loading: false})
        }
      )
      .catch(error => {
        this.setState({error: true, loading: false,})
        this.props.toast.failure("Failed to load locations", "Error")
      })
  }

  render() {

    return (
      <div className="card">
        <div className="card-footerless card-headerless card-body">
          <LocationAuditSearchBar
            name={this.state.name}
            chainName={this.state.chainName}
            country={this.state.country}
            region={this.state.region}
            locality={this.state.locality}
            onSearchSubmit={this.onSearchSubmit}
          />
          <Loading isLoading={this.state.loading}>
            {this.componentToRender()}
          </Loading>
        </div>
      </div>
    )
  }

  componentToRender() {
    if (this.state.error) return (
      <div>
        {this.state.errorMessage || "Something went wrong. Try again later."}
      </div>
    )

    return keys(this.state.rows).length
      ? (<LocationsGrid
          rows={this.state.rows}
          accounts={this.state.accounts}
          categories={this.state.categories}
          onAccountSelect={this.onAccountSelect}
          locations={this.props.locations}
          editorData={this.props.editorData}
          onCreateLocationsSubmitted={this.props.onCreateLocationsSubmitted}
        />
      )
      : (
        <div>
        </div>
      )
  }

}
